import { connect } from 'react-redux';
import { EMPTY_ARRAY, IApplicationState } from '../../../../../../../../types/types';
import { getPanelReadonly } from '../../../../selectors/getPanelReadonly';
import { IChatsHOCProps } from './types';
import { IChatsEvents, IChatsFields } from '../../components/Chats/types';
import { Chats } from '../../components/Chats/Chats';
import { onScopeClick } from './events/onScopeClick';
import { onChange } from './events/onChange';
import { getChatDashboardSettingsByBoardId } from 'app/store/model/chatDashboardSettings/selectors/getChatDashboardSettingsByBoardId';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IChatsHOCProps
): IChatsFields => {
    const chatsSettings = getChatDashboardSettingsByBoardId(state, boardId);
    const scopes = chatsSettings.scope || EMPTY_ARRAY;
    const isReadOnly = getPanelReadonly(state, boardId, null, null);
    const isDisabled = !chatsSettings.enabled;
    return {
        boardId,
        scopes,
        isDisabled,
        isReadOnly
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IChatsHOCProps
): IChatsEvents => {
    return {
        onChange: (scopes) => dispatch(onChange(boardId, scopes)),
        onScopeClick: (scope, checked) => dispatch(onScopeClick(scope, checked))
    }
};

export const ChatsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Chats);

ChatsHOC.displayName = 'ChatsHOC';
